import { ABIAppButton, ABIModal, ModalSize } from '@ab-inbev-labs/ux-react-components';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';

type UserProfileModalProps = {
  onClose: () => void;
  dataTestId?: string;
  children: React.ReactNode;
};

export const UserProfileModal: FC<UserProfileModalProps> = ({ onClose, dataTestId, children }) => {
  const i18next = useTranslation();

  return (
    <ABIModal
      onClose={onClose}
      show
      size={ModalSize.Regular}
      className="user-profile-modal"
      disableCloseButton
      data-testid={dataTestId}
    >
      <div className="message-area">{children}</div>
      <div className="button-area">
        <ABIAppButton onClick={onClose}>{i18next.t('common.actions.close')}</ABIAppButton>
      </div>
    </ABIModal>
  );
};
